import Header from "@/views/admin/com/header.vue";

let router = [
    {
        path: '/admin',
        name: 'admin',
        component: Header,
        redirect: '/admin/shop-console',
        children: [
            {
                //千牛账号
                path: '/admin/shops',
                name: 'admin_shops',
                component: (resolve) => require(['@/views/admin/shops/table.vue'], resolve),
            },
            {
                //拼多多买号
                path: '/admin/pddbuyers',
                name: 'admin_pddbuyers',
                component: (resolve) => require(['@/views/admin/pddbuyer/pdd.vue'], resolve),
            },
            {
                //抖店账号
                path: '/admin/submasters',
                name: 'admin_submasters',
                component: (resolve) => require(['@/views/admin/submaster/table.vue'], resolve),
            },

            {
                //系统子账号
                path: '/admin/doushops',
                name: 'admin_doushops',
                component: (resolve) => require(['@/views/admin/doushop/table.vue'], resolve),
            },
            {
                //微小店
                path: '/admin/weixinshops',
                name: 'admin_weixinshops',
                component: (resolve) => require(['@/views/admin/weixiaodian/table.vue'], resolve),
            },
            {
                //自动发货设置
                path: '/admin/configsend',
                name: 'admin_configsend',
                component: (resolve) => require(['@/views/admin/orders/sendconfig.vue'], resolve),
            },
            {
                //千牛订单
                path: '/admin/orders',
                name: 'admin_orders',
                component: (resolve) => require(['@/views/admin/orders/orders.vue'], resolve),
            },
            {
                //千牛上货工具
                path: '/admin/publish',
                name: 'admin_publish',
                component: (resolve) => require(['@/views/admin/product/publish.vue'], resolve),
            },
            {
                //淘宝买号
                path: '/admin/taobaobuyer',
                name: 'admin_taobaobuyer',
                component: (resolve) => require(['@/views/admin/buyer/taobao.vue'], resolve),
            },
            {
                //淘宝买号 新
                path: '/admin/taobaobuyerv2',
                name: 'admin_taobaobuyerv2',
                component: (resolve) => require(['@/views/admin/buyer/taobaoNew.vue'], resolve),
            },
            {
                //搜索词
                path: '/admin/searchkeyword',
                name: 'admin_searchkeyword',
                component: (resolve) => require(['@/views/admin/keyword/searchkeyword.vue'], resolve),
            },
            {
                //监控店铺
                path: '/admin/monitorshop',
                name: 'admin_monitorshop',
                component: (resolve) => require(['@/views/admin/keyword/monitorshoptable.vue'], resolve),
            },
            {
                //新品监控
                path: '/admin/monitorshopnewgoodtable',
                name: 'admin_monitorshopnewgoodtable',
                component: (resolve) => require(['@/views/admin/keyword/monitorshopnewgoodtable.vue'], resolve),
            },
            {
                //销量监控
                path: '/admin/monitorshopsalegoodtable',
                name: 'admin_monitorshopsalegoodtable',
                component: (resolve) => require(['@/views/admin/keyword/monitorshopsalegoodtable.vue'], resolve),
            },
            {
                //监控审核
                path: '/admin/reviewer',
                name: 'admin_reviewer',
                component: (resolve) => require(['@/views/admin/keyword/reviewer.vue'], resolve),
            },
            {
                //商品复制
                path: '/admin/commodity/copy',
                name: 'admin_commodity_copy',
                component: (resolve) => require(['@/views/admin/commodity/copy/index.vue'], resolve),
                meta: { keepAlive: true }
            },
            {
                //商品复制2
                path: '/admin/commodity/copylist',
                name: 'admin_commodity_copy_list',
                component: (resolve) => require(['@/views/admin/commodity/copylist/index.vue'], resolve),
                meta: { keepAlive: true }
            },
            {
                //铺货上架操作日志
                path: '/admin/commodity/copylist/oplog',
                name: 'admin_commodity_copy_oplog',
                component: (resolve) => require(['@/views/admin/commodity/copylist/oplog.vue'], resolve),
            },
            {
                //搬家设置
                path: '/admin/commodity/settings',
                name: 'admin_commodity_settings',
                component: (resolve) => require(['@/views/admin/commodity/settings/index.vue'], resolve),
            },
            {
                //宝贝搬家
                path: '/admin/banjia/index',
                name: 'admin_banjia_index',
                component: (resolve) => require(['@/views/admin/banjia/index.vue'], resolve),
            },
            {
                //宝贝搬家历史记录
                path: '/admin/banjia/listinghistory',
                name: 'admin_banjia_listinghistory',
                component: (resolve) => require(['@/views/admin/banjia/listinghistory.vue'], resolve),
            },
            {
                //商品库
                path: '/admin/commodity/storehouse',
                name: 'admin_commodity_storehouse',
                component: (resolve) => require(['@/views/admin/commodity/storehouse/index.vue'], resolve),
            },
            {
                //上架历史
                path: '/admin/commodity/listinghistory',
                name: 'admin_commodity_listinghistory',
                component: (resolve) => require(['@/views/admin/commodity/listinghistory/index.vue'], resolve),
            },
            {
                //卡密充值
                path: '/admin/doushop/topup',
                name: 'admin_doushop_topup',
                component: (resolve) => require(['@/views/admin/doushop/topup.vue'], resolve),
            },
            {
                //卡密充值
                path: '/admin/doushop/topup2',
                name: 'admin_doushop_topup2',
                component: (resolve) => require(['@/views/admin/doushop/topup2.vue'], resolve),
            },
            {
                //微小店上架卡密
                path: '/admin/doushop/topup3',
                name: 'admin_doushop_topup3',
                component: (resolve) => require(['@/views/admin/doushop/topup3.vue'], resolve),
            },
            {
                //拼多多解析
                path: '/admin/pddlisten/index',
                name: 'admin_pddlisten_index',
                component: (resolve) => require(['@/views/admin/pddlisten/index.vue'], resolve),
            },
            // {
            //     //测试
            //     path: '/admin/test/test',
            //     name: 'admin_test_test',
            //     component: (resolve) => require(['@/views/admin/test/test.vue'], resolve),
            // },
            {
                // 乘方计划（创建/管理/问题商品 同页 tab）
                path: '/admin/qianchuan/chengfang',
                name: 'admin_qianchuan_chengfang',
                component: (resolve) => require(['@/views/admin/qianchuan/chengfang.vue'], resolve),
            },
            {
                // 全域计划（商品投放/计划管理 同页 tab）
                path: '/admin/qianchuan/quanyu',
                name: 'admin_qianchuan_quanyu',
                component: (resolve) => require(['@/views/admin/qianchuan/quanyu.vue'], resolve),
            },
            {
                // 千川数据（店铺消耗数据，手动添加/刷新）
                path: '/admin/qianchuan/data',
                name: 'admin_qianchuan_data',
                component: (resolve) => require(['@/views/admin/qianchuan/data.vue'], resolve),
            },
            {
                // 千川设置
                path: '/admin/qianchuan/setting',
                name: 'admin_qianchuan_setting',
                component: (resolve) => require(['@/views/admin/qianchuan/setting.vue'], resolve),
            },
            {
                // 草稿箱上架
                path: '/admin/drafts/index',
                name: 'admin_drafts_index',
                component: (resolve) => require(['@/views/admin/drafts/index.vue'], resolve),
            },
            {
                // 商机提报
                path: '/admin/shangjitibao',
                name: 'admin_shangjitibao',
                component: (resolve) => require(['@/views/admin/shangjitibao/index.vue'], resolve),
            },
            {
                path: '/admin/shangjitibao-enhanced',
                name: 'admin_shangjitibao_enhanced',
                component: (resolve) => require(['@/views/admin/shangjitibao/index-enhanced.vue'], resolve),
            },
            {
                path: '/admin/xianshixianlianggou',
                name: 'admin_xianshixianlianggou',
                component: (resolve) => require(['@/views/admin/xianshixianlianggou/index.vue'], resolve),
            },
            {
                path: '/admin/xinrenlijin',
                name: 'admin_xinrenlijin',
                component: (resolve) => require(['@/views/admin/xinrenlijin/index.vue'], resolve),
            },
            {
                path: '/admin/youhuiquan',
                name: 'admin_youhuiquan',
                component: (resolve) => require(['@/views/admin/youhuiquan/index.vue'], resolve),
            },
            {
                path: '/admin/doudian-order-qrcode',
                name: 'admin_doudian_order_qrcode',
                component: (resolve) => require(['@/views/admin/doudian-order-qrcode/index.vue'], resolve),
            },
            {
                path: '/admin/gongzuoliu',
                name: 'admin_gongzuoliu',
                component: (resolve) => require(['@/views/admin/gongzuoliu/index.vue'], resolve),
                meta: { keepAlive: true }
            },
            {
                // 抖店商品编辑（人工鉴图式）
                path: '/admin/doudianShopEdit',
                name: 'admin_doudian_shop_edit',
                component: (resolve) => require(['@/views/admin/doudianShopEdit/index.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                // 批量修改首页
                path: '/admin/piliangxiugai',
                name: 'admin_piliangxiugai',
                component: (resolve) => require(['@/views/admin/piliangxiugai/index.vue'], resolve),
            },
            {
                // 批量修改标题
                path: '/admin/piliangxiugaititle',
                name: 'admin_piliangxiugaititle',
                component: (resolve) => require(['@/views/admin/piliangxiugai/title.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                // 批量修改 SKU 价格
                path: '/admin/piliangxiugaiskuprice',
                name: 'admin_piliangxiugaiskuprice',
                component: (resolve) => require(['@/views/admin/piliangxiugai/skuprice.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                // 批量修改短标题
                path: '/admin/piliangxiugaishorttitle',
                name: 'admin_piliangxiugaishorttitle',
                component: (resolve) => require(['@/views/admin/piliangxiugai/shorttitle.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                // 批量修改品牌
                path: '/admin/piliangxiugaibrand',
                name: 'admin_piliangxiugaibrand',
                component: (resolve) => require(['@/views/admin/piliangxiugai/brand.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                // 批量修改类目属性
                path: '/admin/piliangxiugaicategoryattr',
                name: 'admin_piliangxiugaicategoryattr',
                component: (resolve) => require(['@/views/admin/piliangxiugai/categoryattr.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/admin/piliangxiugaifabricmaterial',
                name: 'admin_piliangxiugaifabricmaterial',
                component: (resolve) => require(['@/views/admin/piliangxiugai/fabricmaterial.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                // 批量修改三包服务承诺
                path: '/admin/piliangxiugaiaftersale',
                name: 'admin_piliangxiugaiaftersale',
                component: (resolve) => require(['@/views/admin/piliangxiugai/aftersale.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/admin/piliangxiugaifreighttemplate',
                name: 'admin_piliangxiugaifreighttemplate',
                component: (resolve) => require(['@/views/admin/piliangxiugai/freighttemplate.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/admin/piliangxiugaiofflinedelete',
                name: 'admin_piliangxiugaiofflinedelete',
                component: (resolve) => require(['@/views/admin/piliangxiugai/offlinedelete.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/admin/piliangxiugaiofflinedeletebydouid',
                name: 'admin_piliangxiugaiofflinedeletebydouid',
                component: (resolve) => require(['@/views/admin/piliangxiugai/offlinedeletebydouid.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/admin/piliangxiugaiviolationbatch',
                name: 'admin_piliangxiugaiviolationbatch',
                component: (resolve) => require(['@/views/admin/piliangxiugai/violationbatch.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/admin/qinglizhixiao',
                name: 'admin_qinglizhixiao',
                component: (resolve) => require(['@/views/admin/qinglizhixiao/index.vue'], resolve),
            },
            {
                path: '/admin/qinglidizhishangpin',
                name: 'admin_qinglidizhishangpin',
                component: (resolve) => require(['@/views/admin/qinglidizhishangpin/index.vue'], resolve),
            },
            {
                path: '/admin/shangpinzhiliangzhenduan',
                name: 'admin_shangpinzhiliangzhenduan',
                component: (resolve) => require(['@/views/admin/shangpinzhiliangzhenduan/index.vue'], resolve),
            },
            {
                path: '/admin/aisee',
                name: 'admin_aisee',
                component: (resolve) => require(['@/views/admin/aisee/index.vue'], resolve),
            },
            {
                path: '/admin/aisee-basic',
                name: 'admin_aisee_basic',
                component: (resolve) => require(['@/views/admin/aisee-basic/index.vue'], resolve),
            },
            {
                path: '/admin/aisee-standard',
                name: 'admin_aisee_standard',
                component: (resolve) => require(['@/views/admin/aisee-standard/index.vue'], resolve),
            },
            {
                path: '/admin/source-video-download',
                name: 'admin_source_video_download',
                component: (resolve) => require(['@/views/admin/source-video-download/index.vue'], resolve),
            },
            {
                path: '/admin/product-selection',
                name: 'admin_product_selection',
                component: (resolve) => require(['@/views/admin/product-selection/index.vue'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/admin/violation-ticket',
                name: 'admin_violation_ticket',
                component: (resolve) => require(['@/views/admin/violation-ticket/index.vue'], resolve),
            },
            {
                path: '/admin/comment-list',
                name: 'admin_comment_list',
                component: (resolve) => require(['@/views/admin/comment-list/index.vue'], resolve),
            },
            {
                path: '/admin/low-sales-zero-sell-clean',
                name: 'admin_low_sales_zero_sell_clean',
                component: (resolve) => require(['@/views/admin/low-sales-zero-sell-clean/index.vue'], resolve),
            },
            {
                path: '/admin/shop-console',
                name: 'admin_shop_console',
                component: (resolve) => require(['@/views/admin/shop-console/index.vue'], resolve),
            },
            {
                path: '/admin/kefu/smart-reply',
                name: 'admin_kefu_smart_reply',
                component: (resolve) => require(['@/views/admin/kefu/smartReply.vue'], resolve),
                meta: { title: '智能回复', keepAlive: true },
            },
            {
                path: '/admin/kefu/reply-log',
                name: 'admin_kefu_reply_log',
                component: (resolve) => require(['@/views/admin/kefu/replyLog.vue'], resolve),
                meta: { title: '回复记录' },
            },
            {
                path: '/admin/kefu/match-rule',
                name: 'admin_kefu_match_rule',
                component: (resolve) => require(['@/views/admin/kefu/matchRule.vue'], resolve),
                meta: { title: '匹配规则' },
            },
            {
                path: '/admin/kefu/attr-synonym',
                name: 'admin_kefu_attr_synonym',
                component: (resolve) => require(['@/views/admin/kefu/attrSynonym.vue'], resolve),
                meta: { title: '属性同义词' },
            },
            {
                path: '/admin/kefu/faq-library',
                name: 'admin_kefu_faq_library',
                component: (resolve) => require(['@/views/admin/kefu/faqLibrary.vue'], resolve),
                meta: { title: '问答库' },
            },
        ]
    },
]
export default router;